import React, { useContext } from "react";
import { useMutation } from "react-query";

import * as api from "../services";
import AppContext from "../appContext";

export default function useSaveLocalMoodboard() {
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  // replace the current moodboard to the client
  const saveBoard = useMutation((board) =>
    api.postLocalMoodboard({
      clientId,
      moodBoardJSON: JSON.stringify(board),
      projectId,
      sessionId,
    })
  );
  return saveBoard;
}
